import catalogos from "./catalogos/temiscivil";
import sistema from "./sistema/temiscivil";

const temiscivil = {
  catalogos: catalogos,
  sistema: sistema
}

export default temiscivil



//////////////////
// WEBPACK FOOTER
// ./static/js/api/temiscivil/temiscivilapi.js
// module id = null
// module chunks = 